import { Link } from 'react-router-dom';
import {
  SunIcon,
  MoonIcon,
  Bars3Icon,
  XMarkIcon,
} from '@heroicons/react/24/outline';

export default function HeaderControls({
  textCls,
  hoverCls,
  darkMode,
  toggleDarkMode,
  mobileOpen,
  setMobileOpen,
}) {
  return (
    <div className="flex items-center gap-2">
      <button
        onClick={toggleDarkMode}
        className={`p-2 rounded-md ${textCls} ${hoverCls} transition-colors duration-200`}
        aria-label={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
        data-testid="dark-mode-toggle"
      >
        {darkMode
          ? <SunIcon className="w-5 h-5" />
          : <MoonIcon className="w-5 h-5" />
        }
      </button>

      <span
        className={`hidden md:block text-xs font-medium px-2 py-1 rounded border ${textCls} opacity-50`}
        style={{ borderColor: 'currentColor' }}
        aria-label="Language: English"
        data-testid="language-indicator"
      >
        EN
      </span>

      <Link
        to="/book-a-call"
        className="hidden md:inline-flex items-center gap-1.5 text-white px-4 py-2 rounded-md text-sm font-medium transition-colors duration-200"
        style={{ backgroundColor: '#0EA5E9' }}
        onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#0369A1'; }}
        onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#0EA5E9'; }}
        data-testid="header-book-call"
      >
        Book a call &rarr;
      </Link>

      <button
        className={`lg:hidden p-2 rounded-md ${textCls} ${hoverCls} transition-colors`}
        onClick={() => setMobileOpen(o => !o)}
        aria-label={mobileOpen ? 'Close navigation' : 'Open navigation'}
        aria-expanded={mobileOpen}
        data-testid="mobile-menu-toggle"
      >
        {mobileOpen
          ? <XMarkIcon className="w-5 h-5" />
          : <Bars3Icon className="w-5 h-5" />
        }
      </button>
    </div>
  );
}
